import React, { Fragment, useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Row, Container, CardBody, Col, Card } from 'reactstrap';
import ReactRouterPropTypes from 'react-router-prop-types';
import PropTypes from 'prop-types';
import { showNotificationAutoDestroy } from '../../shared/components/ShowNotification';
import Modal from '../../shared/components/Modal';
import GraphQl from '../../GraphQL';
import {
  anthropometricMeasurementListByFilter,
  removeWeightMeasureMutation,
} from '../../shared/queries/WeightMeasure';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../redux/actions/loadingActions';
import MatTable from '../../shared/components/material-table';
import columns from './components/Columns';
import {
  getFormattedDate,
  getTranslationAuditStatusByStatus,
  updatePendency,
  getDateWithoutTime,
} from '../../shared/utils/smartutils';

const WeightMeasure = (props) => {
  const [data, setData] = useState([]);
  const [modal, setModal] = useState(false);
  const [selectedDto, setSelectedDto] = useState({});
  const { t, history, dispatch } = props;

  function showLoading() {
    dispatch(changeLoadingTrue());
  }

  function hideLoading() {
    dispatch(changeLoadingFalse());
  }
  const listAllWeightMeasures = () => {
    const filter = {
      filterByStatus: true,
      updaterId: 0,
      active: true,
      id: 0,
      value: 0,
    };
    const query = anthropometricMeasurementListByFilter(filter);
    showLoading();
    GraphQl(query, {})
      .then((res) => {
        res.anthropometricMeasurementListByFilter =
          res.anthropometricMeasurementListByFilter.map((item) => ({
            ...item,
            formattedMeasureDate: getFormattedDate(
              getDateWithoutTime(item.measureDate)
            ),
            auditStatus: getTranslationAuditStatusByStatus(
              t,
              item.timelineIntegrationStatus
            ),
          }));
        setData(res.anthropometricMeasurementListByFilter);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };
  const toggleModal = () => {
    setModal(!modal);
  };

  const deleteItem = () => {
    toggleModal();
    showLoading();
    const removeMutation = removeWeightMeasureMutation(selectedDto.id);
    GraphQl(removeMutation, {})
      .then(() => {
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-removed')
        );
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-remove')
        );
      })
      .finally(() => {
        hideLoading();
        listAllWeightMeasures();
        updatePendency(dispatch);
      });
  };
  const editItemClickHandler = (evt, rowData) => {
    setSelectedDto({
      rowData,
    });
    history.push(`/minime/peso-medida/mnt/${rowData.id}`);
  };
  const addItemClickHandler = () => {
    history.push('/minime/peso-medida/mnt/0');
  };

  const removeItemClickHandler = (evt, rowData) => {
    setSelectedDto({
      ...rowData,
    });
    toggleModal();
  };

  useEffect(() => {
    listAllWeightMeasures();
  }, []);
  return (
    <Fragment>
      <Modal
        color="warning"
        title={t('notifications.attention')}
        btn="Warning"
        message={t('notifications.delete_modal')}
        toggle={toggleModal}
        modal={modal}
        onConfirm={deleteItem}
      />
      <Container>
        <Row className="Table">
          <Col md={12} lg={12}>
            <Card>
              <CardBody className="material-table-card">
                <div className="material-table__wrap">
                  <MatTable
                    data={data}
                    columns={columns(t)}
                    pageSize={20}
                    deleteAction={toggleModal}
                    onRefreshClick={listAllWeightMeasures}
                    onAddClick={addItemClickHandler}
                    onRemoveClick={removeItemClickHandler}
                    onEditClick={editItemClickHandler}
                    title={t('mnt_peso_medida.title')}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};
WeightMeasure.propTypes = {
  t: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  dispatch: PropTypes.func.isRequired,
};
export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(WeightMeasure)
);
